type OrderStatus =
  | "Pending"
  | "Brewing"
  | "Completed"
  | "Claimed"
  | "Cancelled";

export const getTextColorStyle = (status: string) => {
  switch (status) {
    case "Completed":
    case "For Pick-Up":  
      return "text-yellow-600 bg-yellow-100";
    case "Cancelled":
    case "Claimed":
      return "text-gray-400 bg-gray-100";
    case "Pending":
      return "text-red-600 bg-red-100";
    case "Brewing":
      return "text-green-500 bg-green-100";
    // case "Cancelled":
    //   return "text-red-500";
  }
};


export const getTextColorStatusStyle = (status: string) => {
  switch (status) {
    case "Completed":
    case "For Pick-Up":  
      return "text-yellow-600";
    case "Cancelled":
    case "Claimed":
      return "text-gray-400";
    case "Pending":
      return "text-red-600";
    case "Brewing":
      return "text-green-500";
    // case "Cancelled":
    //   return "text-red-500";
  }
};

export const getBorderColorStyle = (status: string) => {
    switch (status) {
    case "Completed": // Pick-up
    case "For Pick-Up":  
        return "border-yellow-600";
    case "Cancelled":
    case "Claimed":
        return "border-gray-400";
    case "Pending":
        return "border-red-600";
    case "Brewing":
        return "border-green-500";
    // case "Cancelled":
    //     return "border-red-500";
    }
  };